import { useState, useMemo, useEffect, useRef } from "react";

import { useSelector } from "react-redux";

import LeftMenu from "../../../Components/Layout/LeftMenu";
import Header from "../../../Components/Layout/Header";

import { ReactComponent as ChartIcon } from "../../../assets/images/sidebar/chart.svg";
import { ReactComponent as ExdIcon } from "../../../assets/images/sidebar/exp_doc.svg";
import { ReactComponent as SettingsIcon } from "../../../assets/images/sidebar/settings.svg";
import { ReactComponent as ManualIcon } from "../../../assets/images/sidebar/manual.svg";

import { ReactComponent as TmM } from "../../../assets/images/settings_icon/template.svg";
import { ReactComponent as PdIcon } from "../../../assets/images/sidebar/planning.svg";
import { ReactComponent as AtIcon } from "../../../assets/images/sidebar/alltrips.svg";
import { ReactComponent as AwbIcon } from "../../../assets/images/sidebar/awb_view.svg"; 
import { ReactComponent as Error } from "../../../assets/images/icon_svg/error.svg"; 
import { ReactComponent as Truck } from "../../../assets/images/icon_svg/truck_icon.svg"; 
import { ReactComponent as ExportIcon } from "../../../assets/images/sidebar/export.svg";
import { ReactComponent as RfsIcon } from "../../../assets/images/sidebar/rfs.svg";
import { ReactComponent as UldIcon } from "../../../assets/images/sidebar/uld.svg";
import MANUAL from '../../../assets/Manual-RFS-Monitor-Airline.pdf'

import Dashboard from './Dashboard';
import TruckOrders from './TruckOrders';
import AwbView from './AwbView';
import SettingsNew from "../../Settings/SettingsNew";
import TODetails from "./TODetails";
import Discrepancies from "./Discrepancies";

const RfsMonitor = () => {

    const initialTab = localStorage.getItem("MainTab");
    const initPage = localStorage.getItem("InnerPage");
    const tabs = ['DB', 'TO', 'AV', 'KC', 'EXP', 'ST', 'ML'].includes(initialTab);

    const [mainTab, setMainTab] = useState(tabs ? initialTab : 'DB');
    const [innerPage, setInnerPage] = useState(initPage || '');
    const initTitle = { title: 'RFS Monitor' }
    const [sendHeader, setSendHeader] = useState(initTitle);
    const [isIconClosed, setIsIconClosed] = useState(true);

    const sections = ['main', 'report', 'settings'];
    const navItems = {
        home: true,
        main: [
            { path: 'DB', name: 'Dashboard', heading: 'Dashboard', icon: <PdIcon className='menu-icon' /> },
            { path: 'TO', name: 'Truck Orders', heading: 'Truck Orders', icon: <Truck className='menu-icon' /> },
            { path: 'AV', name: 'AWB View', heading: 'AWB View', icon: <AwbIcon className='menu-icon' /> },
            { path: 'DS', name: 'Discrepancies', heading: 'Discrepancies', icon: <Error className='menu-icon' /> },
        ],
        report: [
            { path: 'KC', name: 'KPI Charts', uc: true, icon: <ChartIcon className='menu-icon' /> },
            { path: 'EXP', name: 'Export', uc: true, icon: <ExdIcon className='menu-icon' /> },
        ],
        settings: [
            { path: 'ST', name: 'Settings', heading: 'Settings', icon: <SettingsIcon className='menu-icon' /> },
            { path: 'ML', name: 'Manual', module:'RFSMonitor', dName: 'Manual-RFS-Monitor-Airline.pdf', icon: <ManualIcon className='menu-icon' /> },
        ]
    };

    const settingsNav = [
               {
                   name: 'Operations',
                   settingsSearch: true,
                   items: [
                       { name: 'Station Rules', path: '#', icon: <TmM />, tab: 'rfm_str', default: true },
                   ]
               },
    ];
    const handleCollapse = (value) => {
        setIsIconClosed(value);
    };
    useEffect(() => {
        // const findRow = navItems?.main?.main?.find(i => i.path === mainTab)
        const findRow = sections.flatMap(sections => navItems?.[sections] || []).find(i => i.path === mainTab)
        // setSubHead(findRow?.heading || findRow?.name)

        setSendHeader(prev => ({
            ...prev,
            subTitle: findRow?.heading || findRow?.name
        }));
        // if (findRow?.sub && initialSub) {
        //     const subRow = findRow.sub.find(i => i.path === initialSub)
        //     setSubHead(subRow?.heading || subRow?.name)
        // } else {
        //     setSubHead(findRow?.heading || findRow?.name)
        // }
    }, [])

    const handleNavClick = (main = null, page = '', extraInfo) => {

        if (page) {
            setInnerPage(page);
            localStorage.setItem('InnerPage', page);
            localStorage.setItem('DetailsTitle', extraInfo);
            setSendHeader({
                ...initTitle,
                subTitle: page === 'TOD' ? 'Truck Orders' : '',
                extraInfo: extraInfo,
            });
        }
        if (main) {
            if (main === 'ML') {
                // downloadManual()
            } else {
                setInnerPage('');
                localStorage.setItem('InnerPage', '');
                localStorage.removeItem('DetailsTitle');

                setMainTab(main.path);
                const findRow = sections.flatMap(section => navItems?.[section] || []).find(i => i.path === main.path);
                // setSubHead(findRow?.heading || findRow?.name)
                setSendHeader({
                    ...initTitle,
                    subTitle: findRow?.heading || findRow?.name
                });

                localStorage.setItem('MainTab', main.path);
            }


        }
    }

    const downloadManual = (e) => {
        e.preventDefault(); // Prevent the default link behavior
        // const pdfUrl = '/Manual-ULD-Test.pdf'; // Path from the public directory
        const a = document.createElement('a');
        a.href = MANUAL;
        a.download = 'Manual-ULD-Control-Airlines.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };
    // const handleNavClick = (main) => {
    //     // if (['IM', 'EX', 'UL', 'ML'].includes(main)) {
    //     //   toast.warning('Page is under construction!');

    //     // } else {

    //     if (main.sub) {
    //         // if (!initialSub) {
    //         //     const findDefault = main?.sub?.find(i => i.default)
    //         //     setSubTab(findDefault?.path)
    //         //     localStorage.setItem('SubTab', findDefault?.path)
    //         //     setSubHead(findDefault?.heading)
    //         // } else {
    //         //     setSubTab(initialSub)
    //         // }
    //     } else {
    //         const findRow = sections.flatMap(sections => navItems?.[sections] || []).find(i => i.path === main.path)
    //         // setSubHead(findRow?.heading || findRow?.name)
    //         setSendHeader({
    //             ...initTitle,
    //             subTitle: findRow?.heading || findRow?.name
    //         });

    //         if (main.path === 'TOD') {
    //             // setSubHead('Truck Orders')
    //             setSendHeader({
    //                 ...initTitle,
    //                 subTitle: 'Truck Orders',
    //                 extraInfo: `${main.truck_number} / ${main.truck_date}`,
    //             });
    //         }
    //     }
    //     setMainTab(main.path);
    //     localStorage.setItem('MainTab', main.path);
    // }

    return (
        <div className="d-flex">
            <LeftMenu isIconClosed={isIconClosed} selTab={mainTab} navs={navItems} onNav={handleNavClick} />
            <div className="mainbody-right">
                <Header isIconClosed={isIconClosed} oncollapsed={handleCollapse} propData={sendHeader} />

                <div className="">
                    {innerPage === '' &&
                        <>
                            {mainTab === 'DB' && <Dashboard onDetails={handleNavClick}/>}
                            {mainTab === 'TO' && <TruckOrders onDetails={handleNavClick} />}
                            {mainTab === 'AV' && <AwbView onDetails={handleNavClick}/>}
                            {mainTab === 'DS' && <Discrepancies onDetails={handleNavClick}/>}
                            {mainTab === 'ST' && <SettingsNew onSnav={settingsNav} />}
                        </>
                    }
                    {innerPage === 'TOD' && <TODetails  onTitleChange={(newTitle) => {
                        localStorage.setItem('DetailsTitle', newTitle);
                        setSendHeader(prev => ({ ...prev, extraInfo: newTitle }));
                        }} />}
                </div>
            </div>
        </div >
    )
}

export default RfsMonitor